import React from 'react'
import { Global } from '@emotion/react'

import { MediaContextProvider } from './src/contexts/responsive'
import FirebaseProvider from './src/contexts/firebase/provider'
import globalStyles from './global-styles'

const Providers = ({ element }) => (
  <FirebaseProvider>
    <MediaContextProvider>
      <>
        <Global styles={globalStyles} />
        {element}
      </>
    </MediaContextProvider>
  </FirebaseProvider>
)
export default Providers
